import { render, staticRenderFns } from "./UbahAkses.vue?vue&type=template&id=b8ad270a&"
import script from "./UbahAkses.vue?vue&type=script&lang=js&"
export * from "./UbahAkses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports